<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >

        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            plain
            @click.stop="handleAdd()"
          >新增
          </el-button>
          <el-button
            type="warning"
            icon="el-icon-check"
            size="small"
            plain
            @click.stop="handleDel('DELETE_OPTION','逻辑删除')"
          >删除</el-button>
          <el-button
            type="danger"
            icon="el-icon-check"
            size="small"
            plain
            @click.stop="handleDel('DELETE_OPTION','物理删除')"
          >物理删除</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
            type="primary"
            size="small"
            plain
            @click.stop="handleEdit(scope.row,scope.index)"
          >编辑
          </el-button>
          <el-button
            type="primary"
            size="small"
            plain
            @click.stop="toDetail(scope.row,scope.index)"
          >查看
          </el-button>
        </template>
        <template
          slot-scope="scope"
          slot="status"
        >
          <el-tag
            v-for="obj of status"
            :key="obj.value"
            v-if="obj.value == scope.row.status"
          >
            {{obj.label}}
          </el-tag>
        </template>
        <template
          slot-scope="scope"
          slot="joinsWorkServiceCategory"
        >
          <el-tag v-if="scope.row.serviceCategoryName != null">
            {{scope.row.serviceCategoryName}}
          </el-tag>
        </template>
        <template
          slot-scope="scope"
          slot="joinsWorkServiceItem"
        >
          <el-tag v-if="scope.row.serviceItemName != null">{{scope.row.serviceItemName }}
          </el-tag>
        </template>
        <template
          slot-scope="scope"
          slot="clientType"
        >
          <el-tag
            v-for="useCustomerType in formatClientType(scope.row.useCustomerType)"
            v-bind:key="useCustomerType.value"
          >
            {{useCustomerType.label}}
          </el-tag>
        </template>
        <template
          slot-scope="scope"
          slot="joinsWorkServiceCategoryForm"
        >
          <el-select
            v-model="joinsWorkServiceCategory"
            placeholder="请选择服务类目"
            required
            @change="choseWorkServiceItem"
            value-key="id"
          >
            <el-option
              v-for="joinsWorkServiceCategory in joinsWorkServiceCategorys"
              :key="joinsWorkServiceCategory.id"
              :label="joinsWorkServiceCategory.name"
              :value="joinsWorkServiceCategory"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="joinsWorkServiceItemForm"
        >
          <el-select
            v-model="joinsWorkServiceItem"
            placeholder="请选择服务项目"
            required
            value-key="id"
          >
            <el-option
              v-for="joinsWorkServiceItem in joinsWorkServiceItems"
              :key="joinsWorkServiceItem.id"
              :label="joinsWorkServiceItem.name"
              :value="joinsWorkServiceItem"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="clientTypeForm"
        >
          <el-select
            v-model="clientType"
            placeholder="用户类型"
            multiple
            required
            value-key="value"
          >
            <el-option
              v-for="obj in clientTypes"
              :key="obj.value"
              :label="obj.label"
              :value="obj"
            ></el-option>
          </el-select>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { serviceCouponOption } from "@/const/salesCloud/serviceCouponOption";
import {
  findCouponList,
  addCoupon,
  editCoupon,
  delCoupon
} from "@/api/salesCloud/serviceCoupon";
import {
  findCategoryAll,
  findItemsByCategory
} from "@/api/salesCloud/workOrder";
import {
  findProject
} from "@/api/work/dtTable";
import { findByLabel } from "@/util/util";
import { DIC } from "@/const/dic";

export default {
  name: "serviceCoupon",
  components: {},
  data() {
    return {
      tableOption: serviceCouponOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      },
      status: DIC.EXIT_RULE_STATUS,
      joinsWorkServiceCategorys: [],
      joinsWorkServiceCategory: {},
      joinsWorkServiceItems: [],
      joinsWorkServiceItem: {},
      clientTypes: DIC.CLIENT_TYPE,
      clientType: []
    };
  },
  created() {
    // findCategoryAll().then(res => {
    //   let data = JSON.parse(res.data);
    //   this.joinsWorkServiceCategorys = data.rows;
    // });
    findProject().then(res => {
      let data = JSON.parse(res.data);
      this.joinsWorkServiceCategorys = data;
    });
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    toDetail(row, index) {
      console.log(row, index);
      let params = {};
      params.id = row.id;
      this.$router.push({ name: "服务优惠券明细列表", params });
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      (params.page = this.page.currentPage), (params.size = pageSize);
      findCouponList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      findCouponList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      findCouponList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      findCouponList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.clean();
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      this.clean();
      this.clientType = this.formatClientType(row.useCustomerType);
      this.joinsWorkServiceCategory = { id: row.serviceCategoryId };
      this.choseWorkServiceItem();
      this.joinsWorkServiceItem = { id: row.serviceItemId };
      if (row.startTime != null && row.endTime != null) {
        let array = [];
        array.push(row.startTime);
        array.push(row.endTime);
        row.startTime_endTime = array;
      }
      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      findCouponList(parmas).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      if (null != row.startTime_endTime && undefined != row.startTime_endTime) {
        row.startTime = row.startTime_endTime[0];
        row.endTime = row.startTime_endTime[1];
      }
      let str = "";
      for (let i = 0; i < this.clientType.length; i++) {
        str += this.clientType[i].value + ":";
      }
      str = str.substring(0, str.length - 1);
      row.serviceCategoryId = this.joinsWorkServiceCategory.id;
      row.serviceItemId = this.joinsWorkServiceItem.id;
      row.useCustomerType = str;
      console.log(row);
      addCoupon(row)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
      // console.log(val);
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(dicName, label) {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error"
        });
        return;
      }

      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }

          delCoupon(findByLabel(DIC.DELETE_OPTION, label), ids)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => {});
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      if (null != row.startTime_endTime && undefined != row.startTime_endTime) {
        row.startTime = row.startTime_endTime[0];
        row.endTime = row.startTime_endTime[1];
      }
      let str = "";
      for (let i = 0; i < this.clientType.length; i++) {
        str += this.clientType[i].value + ":";
      }
      str = str.substring(0, str.length - 1);
      row.serviceCategoryId = this.joinsWorkServiceCategory.id;
      row.serviceItemId = this.joinsWorkServiceItem.id;
      row.useCustomerType = str;
      editCoupon(row)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "修改成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },
    choseWorkServiceItem() {
      // findItemsByCategory(this.joinsWorkServiceCategory.id).then(res => {
      //   let data = JSON.parse(res.data);
      //   this.joinsWorkServiceItems = data;
      // });
      let params = {};
      params.superiorId = this.joinsWorkServiceCategory.id;
      findProject(params).then(res => {
        let data = JSON.parse(res.data);
        this.joinsWorkServiceItems = data;
      });

    },
    formatClientType(value) {
      let clientType = value.split(":");
      let array = [];
      for (let i = 0; i < clientType.length; i++) {
        for (let j = 0; j < this.clientTypes.length; j++) {
          if (clientType[i] == this.clientTypes[j].value) {
            array.push(this.clientTypes[j]);
          }
        }
      }
      return array;
    },
    clean() {
      this.joinsWorkServiceCategory = {};
      this.joinsWorkServiceItem = {};
      this.clientType = [];
    }
  }
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
